import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';

import { Subject } from 'rxjs';
import { filter, pairwise, takeUntil } from 'rxjs/operators';

import { CoreConfigService } from '@core/services/config.service';
import { Router, RoutesRecognized } from '@angular/router';

import * as _ from 'lodash';
import { PrivilegeService } from '@core/services/privilege.service';

@Component({
	selector: 'main-layout',
	templateUrl: './main-layout.component.html',
	styleUrls: ['./main-layout.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class MainLayoutComponent implements OnInit, OnDestroy {
	// Public
	coreConfig: any;

	// Private
	private _unsubscribeAll$: Subject<any>;

	/**
	 * Constructor
	 *
	 * @param {CoreConfigService} _coreConfigService
	 */
	constructor(private _coreConfigService: CoreConfigService,
		private _router: Router,
		private _privilegeService: PrivilegeService) {

		// Set the private defaults
		this._unsubscribeAll$ = new Subject();
	}

	// Lifecycle Hooks
	// -----------------------------------------------------------------------------------------------------

	/**
	 * On init
	 */
	ngOnInit(): void {
		// Subscribe to config changes
		this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll$)).subscribe(config => {
			this.coreConfig = config;
		});

		// Subscribe clear cookie if navigate to login from /paged
		this._router.events
			.pipe(takeUntil(this._unsubscribeAll$), filter((evt: any) => evt instanceof RoutesRecognized), pairwise())
			.subscribe((events: RoutesRecognized[]) => {
				const previous = events[0].urlAfterRedirects;
				const current = events[1].urlAfterRedirects;
				if(previous.startsWith('/pages') && current === '/login') this._privilegeService.clearCookie();
			});
	}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {
		// Unsubscribe from all subscriptions
		this._unsubscribeAll$.next();
		this._unsubscribeAll$.complete();
	}
}
